import {
  Body,
  BottomSheet,
  Button,
  Heading,
} from "@songtradr-one/components-frontend";
import {
  MobileButtonsColumn,
  MobileContent,
  Props,
  text,
} from "./ModalConfirm.Parts";

export const ModalConfirmMobile = ({
  open,
  title,
  loading,
  description,
  cancelLabel,
  confirmLabel,
  confirmVariant = "primary",
  onConfirm,
  onOpenChange,
  onCancel,
  preventDismiss,
  children,
}: Props) => (
  <BottomSheet
    open={open}
    draggable={!preventDismiss}
    onOpenChange={preventDismiss ? undefined : onOpenChange}
    hiddenTitle={title}
    hiddenDescription={description}
  >
    <MobileContent>
      <Heading variant="h3-strong">{title}</Heading>
      {description && <Body>{description}</Body>}
      {children}
    </MobileContent>
    <MobileButtonsColumn>
      <Button $variant={confirmVariant} onClick={onConfirm} loading={loading}>
        {confirmLabel}
      </Button>
      {!preventDismiss && (
        <Button
          $variant="subtle"
          onClick={() => (onCancel ? onCancel() : onOpenChange(false))}
        >
          {cancelLabel || text.shared.cancel}
        </Button>
      )}
    </MobileButtonsColumn>
  </BottomSheet>
);
